import useProjectId from './hooks/useProjectId';
import {
    useBrand,
    useInvalidateProject,
    usePartnership,
    useProject,
    useTeam,
    useUsers,
} from '@round/creatorbase-helpers/api-hooks';
import { useFeatureFlags } from 'utility/featureFlags/FeatureFlagsContext';

export default function useProjectDetails() {
    const projectId = useProjectId();
    const { data: project, isLoading, status } = useProject(projectId, { enabled: typeof projectId === 'number' });
    const {
        data: brand,
        isLoading: isBrandLoading,
        isSuccess: isBrandSuccess,
    } = useBrand(project?.brand_id, {
        enabled: typeof project?.brand_id === 'number',
    });

    const {
        data: team,
        isLoading: isTeamLoading,
        isSuccess: isTeamSuccess,
    } = useTeam(
        project?.team_id,
        {},
        // a received project's team belongs to the owner, which the recipient can't read
        { enabled: typeof project?.team_id === 'number' && typeof project.owned_by !== 'number' }
    );

    const isProjectSharingEnabled = useFeatureFlags().isEnabled('project_sharing');
    const { data: partnership, isLoading: isPartnershipLoading } = usePartnership(project?.owned_by, {
        enabled: isProjectSharingEnabled && typeof project?.owned_by === 'number',
    });

    const { data: users, isLoading: areUsersLoading } = useUsers(
        {
            id: project?.users_assigned_to_campaigns.toString(),
            page_size: project?.users_assigned_to_campaigns.length,
        },
        { enabled: !!project?.users_assigned_to_campaigns.length }
    );

    return {
        project,
        brand,
        team,
        partnership,
        users,
        status,
        isLoading,
        isBrandLoading,
        isBrandSuccess,
        isTeamLoading,
        isTeamSuccess,
        isPartnershipLoading,
        areUsersLoading,
    };
}

export function useInvalidateProjectData() {
    const invalidate = useInvalidateProject();
    const projectId = useProjectId();

    return async () => {
        if (projectId) {
            return invalidate(projectId);
        }
    };
}
